<div class="group-images-picker-list crm-scroll"
     cdkDropList
     cdkDropListOrientation="mixed"
     (cdkDropListDropped)="onDrop($event)">
  @for (img of imagesControl.value; let i = $index; track i) {
    <div class="group-images-picker-item group-images-picker-item-move"
         cdkDrag>
      <div class="group-images-picker-action">
        <app-button class="group-images-picker-item-delete"
                    btnType="icon"
                    (click)="onDelete(i)">
          <app-icon>delete</app-icon>
        </app-button>
      </div>

      <img class="group-images-picker-img" [src]="img.url" alt="advert image {{i}}">

      @if (i === 0) {
        <div class="group-images-picker-main-badge">
          {{ 'main' | translate }}
        </div>
      }
    </div>
  }
  @for (_ of emptyImageBlocks; track $index) {
    <div (click)="onAddImage()"
         class="group-images-picker-item click-css">
      <div class="group-images-picker-img">
        {{ 'add_photo' | translate }}
      </div>
    </div>
  }
</div>
